import React from 'react'
import { Container, handleImgixUrl } from '@kogk/common'

type GridElement = {
  logo: {
    url: string
    alt: string
  }
  name: string
  url: string
}

export interface ImageGridInterface {
  headline: string
  elements: GridElement[]
}

const GridElementBox: React.FC<{ gridElement: GridElement }> = ({ gridElement }) => (
  <div className='image-grid-box col-6 col-md-3 pb-2'>
    <a target='_blank' href={gridElement.url} className='flex-wrap completeCenter'>
      <img src={handleImgixUrl(gridElement.logo.url).url()} alt='grid element' />
    </a>
  </div>
)

const ImageGrid: React.FC<ImageGridInterface> = ({ headline, elements }) => {
  if (!elements) return null

  return (
    <Container className='page-slice-spacer'>
      <h2 className='mt-4 mb-4'>{headline}</h2>
      <div className='d-flex flex-wrap image-grid-wrap'>
        {elements
          .filter(item => item.logo.url)
          .map((item, idx) => (
            <GridElementBox key={idx} gridElement={item} />
          ))}
      </div>
    </Container>
  )
}

export default ImageGrid
